<div class="floating-panel" [ngClass]="{show: show}">
    <div class="title d-flex justify-content-between align-items-center">
        <p class="clickable">
            <span *ngIf="(today && selectedDay) && today.getTime() === selectedDay.getTime()">{{ 'ACTIVITY_SIDEBAR.today' | translate }},</span> {{selectedDay | date:'EEEE d MMMM y'}}
        </p>
        <div class="d-flex">
            <onwac-button 
            *ngIf="(today && selectedDay) && today.getTime() != selectedDay.getTime()"
            [text]="'ACTIVITY_SIDEBAR.today' | translate "
            [type]="'bordered'" 
            (click)="loadDay(today)"></onwac-button>
            <onwac-button 
            [text]="'MEETINGS_MANAGEMENT.prev' | translate"
            [type]="'icon'" 
            [icon]="'chevron_left'" 
            (click)="changeDay('down')"></onwac-button>
            <onwac-button 
            [text]="'MEETINGS_MANAGEMENT.next' | translate" 
            [type]="'icon'" 
            [icon]="'chevron_right'" 
            (click)="changeDay('up')"></onwac-button>
        </div>
    </div>
    <div class="load-content">
        <app-progress-bar [options]="progressBarOptions"></app-progress-bar>

        <div class="section">
            <div class="section-name">
                {{'MEETINGS_MANAGEMENT.myTodaySchedule' | translate}}
            </div>
            
            <div class="meeting-row" 
            [ngClass]="{hidden: pbComponent && pbComponent.visible}"
            *ngFor="let meeting of todaySchedule">
                <div class="hour">
                    <p>{{meeting.startHour | date:'HH:mm'}} - {{meeting.endHour | date:'HH:mm'}}</p>
                </div>
                <div class="deal">
                    <p class="name color-white">{{meeting.deal_name}}</p>
                    <p>{{meeting.user_data}}</p>
                </div>
            </div>
            <div *ngIf="todaySchedule.length === 0">
                <p class="small">{{'MEETINGS_MANAGEMENT.noMeetingsToday' | translate}}</p>
            </div>
        </div>
        
        <div class="section">
            <div class="section-name">
                {{'MEETINGS_MANAGEMENT.pendingMeetings' | translate}}
            </div>
    
            <div class="pending-meeting-row" *ngFor="let meeting of nextMeetings">
                <p class="date clickable" (click)="loadDay(meeting.startHour)">{{meeting.startHour | date: 'dd/MM/yyyy HH:mm'}} - {{meeting.endHour | date:'HH:mm'}}</p>
                <p>{{meeting.user_data}} {{'MEETINGS_MANAGEMENT.of' | translate}} <span>{{meeting.deal_name}}</span> {{'MEETINGS_MANAGEMENT.meetingRequest' | translate}}</p>
                <div class="button-row full-width">
                    <onwac-button (click)="openConfirmModal(false, meeting)" [text]="'MEETINGS_MANAGEMENT.reject' | translate" [type]="'text'" [extra_clases]="'block'"></onwac-button>
                    <onwac-button (click)="openConfirmModal(true, meeting)" [text]="'MEETINGS_MANAGEMENT.accept' | translate" [extra_clases]="'block'"></onwac-button>
                </div>
            </div>

            <p class="small" *ngIf="nextMeetings.length === 0">
                {{'MEETINGS_MANAGEMENT.noNewRequests' | translate}}
            </p>
        </div>
    </div>
    
</div>
<onwac-modal *ngIf="areYouSureModal"
[title]="areYouSureModal.title" 
[show]="areYouSureModal.isVisible"
[trueActionText]="'MEETINGS_MANAGEMENT.accept' | translate" 
[falseActionText]="'MEETINGS_MANAGEMENT.cancel' | translate" 
(callback)="getModalResult($event)">
<div slot="content">
    <p class="text-center">
        {{areYouSureModal.text}}
    </p>
</div>
</onwac-modal>

<div class="overlay" [ngClass]="{show: show}" (click)="toggle()"></div>